class VwHastamuracaatDTO {
    id: number = null;
    kimlikId?: number = null;
    tarih?: string = null;
    ad?: string = "";
    soyad?: string = "";
    servisId?: number = null;
    doktorId?: number = null;
    kurumId?: number = null;
    sevkTarihi?: string = null;
    sevkNo?: string = "";
    kurumSicilNo?: string = "";
    kayitTurId?: number = null;
    kartYakinId?: number = null;
    oncelikId?: number = null;
    anneKimlikNo?: number = null;
    ucretTarifeTanimId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    bebekId?: number = null;
    referansDoktorId?: number = null;
    organizasyonId?: number = null;
    notlar?: string = "";
    endikasyonlar?: string = "";
    kurumprotokolno?: string = "";
    boy?: number = null;
    kilo?: number = null;
    sevkliHasta?: string = "H";
    sigortaKurumId?: number = null;
    hastaliktanimtaniId?: number = null;
    hastaliktanimId?: number = null;
    kayitTipi?: string = "A"; //"G" "Y" "A"
    kurum?: string = "";
    tarife?: string = "";
    servistOrganizasyonId?: number = null;
    fkHbsBransId?: number = null;
    bransResmikodu?: string = "";

    //View dışı
    aynibransaynigunpolyok?: string = "H"
    kurumAdi?: string = "";
    calisanBilgileri?: number = null;
};
export default VwHastamuracaatDTO;